import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PromotionPopup from "@/components/PromotionPopup";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import MissionPage from "@/pages/MissionPage";
import EpisodesPage from "@/pages/EpisodesPage";
import GetInvolvedPage from "@/pages/GetInvolvedPage";
import ContactPage from "@/pages/ContactPage";
import SharePage from "@/pages/SharePage";
import EventsPage from "@/pages/EventsPage";
import TicketSuccessPage from "@/pages/TicketSuccessPage";
import ScannerPage from "@/pages/ScannerPage";
import ResourcesPage from "@/pages/ResourcesPage";
import SponsorVeteranPage from "@/pages/SponsorVeteranPage";
import FitnessCampPage from "@/pages/FitnessCampPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import { Toaster } from "sonner";

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <div className="bg-black min-h-screen text-white font-body">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/mission" element={<MissionPage />} />
          <Route path="/episodes" element={<EpisodesPage />} />
          <Route path="/get-involved" element={<GetInvolvedPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/tickets/success" element={<TicketSuccessPage />} />
          <Route path="/scanner" element={<ScannerPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/sponsor-veteran" element={<SponsorVeteranPage />} />
          <Route path="/fitness-camp" element={<FitnessCampPage />} />
          <Route path="/share" element={<SharePage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <PromotionPopup />}
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff',
            fontFamily: 'IBM Plex Sans, sans-serif'
          }
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
